import $ from "jquery";
import { isInViewport } from "../../../../Static/Js/typescript/Vgr.Util";

$(() => {
    const elements: NodeListOf<Element> = document.querySelectorAll('.expanded-block [data-minimize], .search-control-block [data-minimize], .ifeed-block [data-minimize]');

    if (elements.length > 0) {
        elements.forEach((el: Element) => {

            el.addEventListener('click', () => {
                const detailsElem = (el as HTMLElement).closest("details") as HTMLDetailsElement | null;
                if (detailsElem != null) {
                    const summaryElem = detailsElem.querySelector(':scope > summary') as HTMLElement | null;
                    detailsElem.removeAttribute('open');

                    if (!isInViewport(detailsElem)) {
                        // Blocket kan vara långt när det är utfällt.
                        // Därför är det vikitgt att man kommer tillbaka till den delen av sidan man stod på när man fällde ut blocket. 
                        detailsElem.scrollIntoView();
                    }

                    // The minimize button is inside the details and disappears on collapse,
                    // so move focus back to the summary (the disclosure trigger).
                    summaryElem?.focus();
                }
            });
        })
    }
});